import React from 'react';
import { Input } from '../ui/input';

/** Текущий месяц по Москве — с него по умолчанию действует новая цена. */
export function currentMonthMsk(now = new Date()) {
  return new Date(now.getTime() + 3 * 3600 * 1000).toISOString().slice(0, 7);
}

/**
 * Что отправить в PATCH: {since, rub} — новая цена или «бесплатно» (rub=null),
 * null — ничего не менялось, 'invalid' — в поле не число больше нуля.
 */
export function buildMinuteRate(rateInput, since, current) {
  const raw = (rateInput || '').trim().replace(',', '.');
  if (raw === '') return current == null ? null : { since, rub: null };
  const rub = Number(raw);
  if (!Number.isFinite(rub) || rub <= 0) return 'invalid';
  if (current != null && rub === current) return null;
  return { since, rub };
}

const fmt = (rub) => (rub == null ? 'бесплатно' : `${String(rub).replace('.', ',')} ₽`);

/** Договорная цена минуты контрагента: по ней 1-го числа собираются счета на взаимозачёт. */
export default function MinuteRateFields({ rate, since, history = [], onRateChange, onSinceChange }) {
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <div className="flex-1">
          <label htmlFor="edit-minute-rate" className="text-xs text-paper-ink-3 block mb-1">Цена минуты, ₽</label>
          <Input id="edit-minute-rate" value={rate} onChange={(e) => onRateChange(e.target.value)}
            placeholder="не платит" inputMode="decimal" />
        </div>
        <div>
          <label htmlFor="edit-minute-since" className="text-xs text-paper-ink-3 block mb-1">Действует с</label>
          <Input id="edit-minute-since" type="month" value={since} onChange={(e) => onSinceChange(e.target.value)} />
        </div>
      </div>
      <p className="text-[11px] text-paper-hint">
        Договорная цена для счёта на взаимозачёт, не себестоимость. Пусто — счёт не выставляется.
      </p>
      {history.length > 0 && (
        <ul className="text-xs text-paper-ink-3">
          {history.map((h) => <li key={h.since}>с {h.since} — {fmt(h.rub)}</li>)}
        </ul>
      )}
    </div>
  );
}
